import { createPortal } from 'react-dom';
import classes from './BlockScreen.module.css';

const BlockScreen = () => {

    return createPortal(
       <div className={classes.BlockScreen}>
       </div>
    , document.body)
}

export default BlockScreen;